import React from 'react';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';

interface IProps {
  title: string;
  background: string;
  content: React.ReactNode;
}

const GradientCard: React.FC<IProps> = ({ background, title, content }) => {
  const t = useTranslations();

  return (
    <div
      className={classNames(background, 'h-53.5 flex flex-col justify-between rounded-xl px-3 pb-1.5 pt-3 overflow-hidden relative')}
    >
      <div>
        <div className="font-semibold text-gray-800">{title}</div>
        <div className="text-xs font-medium text-gray-400">{t('barchasiga')}</div>
      </div>
      {content}
    </div>
  );
};

export default GradientCard;
